<template>
  <div class="more-content" :class="$device.isMobile ? 'mobile' : 'desktop'">
    <div class="primary-links">
      <h2>{{ $t('功能') }}</h2>
      <div
        v-for="tab in primaryLinks"
        :key="tab.event"
        class="w-100 position-relative"
      >
        <div class="primary-button" @click="onClickEvent(tab)">
          <img width="60" :src="tab.img" />
          <h2 class="flex-1">{{ tab.title || $t(tab.name) }}</h2>
        </div>
        <div
          v-if="tab.hasNotification"
          class="notification bg-accent position-absolute"
        ></div>
      </div>
    </div>

    <div class="secondary-links">
      <h2>{{ $t('其他') }}</h2>
      <div v-for="link in secondaryLinks" :key="link.event" class="w-100">
        <div class="secondary-button" @click="onClickEvent(link)">
          <i class="text-32 text-primary" :class="`icon-${link.icon}`"></i>
          <h4>{{ link.title || $t(link.name) }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import verificationImage from '@/assets/img/icon/verification.svg';
import myKifusImage from '@/assets/img/icon/myKifus.svg';
import goPageMixin from '@/mixin/goPage';
import {Device} from '@capacitor/device';
import {mapGetters} from 'vuex';

export default {
  mixins: [goPageMixin],
  data() {
    return {
      isCameraToScoreGameList: false,
      platform: 'web',
    };
  },
  computed: {
    ...mapGetters('env', ['isIos', 'isAndroid']),
    isChinese() {
      return this.$store.getters['env/isChinese'];
    },
    isEnglish() {
      return this.$store.getters['env/isEnglish'];
    },
    hasCamera() {
      return this.isIos || this.isAndroid;
    },
    primaryLinks() {
      const list = [
        {
          img: verificationImage,
          event: 'verificationList',
          name: '模擬檢定',
          hasNotification: this.$store.state.env.hasVerificationNotification,
        },
        {
          img: myKifusImage,
          event: 'kifus',
          name: '我的棋譜',
        },
      ];
      return list.filter((item) => !item.isHidden);
    },
    secondaryLinks() {
      const list = [
        {
          icon: 'Camera',
          title: this.$t('{boardSize}路拍照數地', {boardSize: 19}),
          isHidden: this.platform === 'web',
          event: 'camera19',
        },
        {
          icon: 'Senserobot',
          event: 'goRobot',
          isHidden: !this.isChinese,
          name: 'AI圍棋機器人',
        },
        {
          icon: 'Cards',
          event: 'cardgolegends',
          isHidden: !this.isChinese && !this.isEnglish,
          name: '烏鷺爭霸',
        },
        {
          icon: 'Location',
          event: 'brickAndMortarStore',
          name: '實體據點',
        },
      ];
      return list.filter((item) => !item.isHidden);
    },
  },
  methods: {
    async onClickEvent(tab) {
      this.$emit('click', tab);
      const {event} = tab;
      switch (event) {
        case 'brickAndMortarStore':
          this.$openHomePage('/kidgo#trial-listen');
          break;
        case 'cameraToScoreGame':
          this.isCameraToScoreGameList = true;
          break;
        case 'camera9':
          this.isCameraToScoreGameList = false;
          this.goCameraToScoreGame(9);
          break;
        case 'camera13':
          this.isCameraToScoreGameList = false;
          this.goCameraToScoreGame(13);
          break;
        case 'camera19':
          this.isCameraToScoreGameList = false;
          this.goCameraToScoreGame(19);
          break;
        case 'cardgolegends':
          if (this.isEnglish) {
            return this.hasCamera
              ? this.$router.push({name: 'cardgolegendsCameraToScoreGame'})
              : this.showedCameraAlert();
          }
          this.goPage('cardgolegends');
          break;
        default:
          this.goPage(event);
      }
    },
    async showedCameraAlert() {
      await this.$alert({
        message: this.$t('請使用手機操作《烏鷺爭霸》的拍照數地功能'),
        confirm: this.$t('知道了'),
      });
    },
  },
  async created() {
    const {platform} = await Device.getInfo();
    this.platform = platform;
  },
};
</script>

<style lang="scss" scoped>
.more-content {
  display: flex;
  width: 383px;
  max-width: 100%;
  padding: var(--spacing-m, 24px);
  flex-direction: column;
  align-items: stretch;
  gap: 48px;
  .primary-links,
  .secondary-links {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-s, 16px);
    align-self: stretch;
  }
  .primary-button {
    display: flex;
    padding: var(--spacing-m, 16px) var(--spacing-m, 24px);
    align-items: center;
    gap: var(--spacing-m, 24px);
    align-self: stretch;
    border-radius: var(--Radius-radius-l, 20px);
    background: var(--Background-style-1, #fff);
    box-shadow: 0px 4px 20px 0px rgba(199, 199, 199, 0.35);
    cursor: pointer;
  }
  .secondary-button {
    display: flex;
    height: 60px;
    padding: 8px 16px;
    align-items: center;
    gap: 16px;
    align-self: stretch;
    border-radius: var(--Radius-radius-m, 10px);
    background: $white;
    box-shadow: 0px 4px 20px 0px rgba(199, 199, 199, 0.35);
    cursor: pointer;
  }

  &.mobile {
    width: 100%;
  }
}
.notification {
  width: 14px;
  height: 14px;
  top: 16px;
  right: 16px;
  border-radius: 50%;
}
</style>
